import { render } from "./HelpAi.vue?vue&type=template&id=3ba7ec84&scoped=true"
import script from "./HelpAi.vue?vue&type=script&lang=js"
export * from "./HelpAi.vue?vue&type=script&lang=js"

import "./HelpAi.vue?vue&type=style&index=0&id=3ba7ec84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba7ec84"]])

export default __exports__